export default "__VITE_ASSET__CSjc1jlo__"